var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.494 0A7.493 7.493 0 0 1 15 7.506 7.491 7.491 0 0 1 7.494 15 7.488 7.488 0 0 1 0 7.506 7.49 7.49 0 0 1 7.494 0Zm0 .75A6.74 6.74 0 0 0 .75 7.505a6.74 6.74 0 0 0 6.744 6.745 6.742 6.742 0 0 0 6.756-6.745A6.743 6.743 0 0 0 7.494.75Zm.006 9.563c.32 0 .563.242.563.562a.555.555 0 0 1-.563.563.559.559 0 0 1-.563-.563c0-.32.25-.563.563-.563Zm.214-6.563c1.417 0 2.336.9 2.336 2.094 0 .865-.585 1.48-1.39 1.994-.771.49-.839.824-.839 1.473v.439H7.04V9.2c-.006-.772.185-1.263 1.009-1.795.735-.485 1.173-.895 1.173-1.526 0-.83-.59-1.433-1.536-1.433-.941 0-1.594.585-1.67 1.509H5.25c.07-1.24.947-2.205 2.464-2.205Z",
  fill: "#000",
  fillRule: "nonzero"
})));

export default SvgHelp;